// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2NgD5","right":"styles_right__3dtrG","left":"styles_left__3_sUd","down":"styles_down__39VGc","active":"styles_active__gJmMI"};